const obrigatorios = [10, 20];
export default {
	methods: {
		is_preenched(exam) {
			let notPreenched = 0;
			obrigatorios.forEach((item) => {
				const index = exam.linhas.findIndex(
					(eItem) => eItem.campo == item
				);
				if (index == -1) return;
				if (exam.linhas[index].value == '') notPreenched++;
			});
			return notPreenched == 0;
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/sd2000/solicitacoes/mdExams/fxExams.mixin.js